var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 20 20"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M10.625 4.167a.625.625 0 0 0-1.25 0v5.208H4.167a.625.625 0 1 0 0 1.25h5.208v5.209a.625.625 0 0 0 1.25 0v-5.209h5.208a.625.625 0 1 0 0-1.25h-5.208z"}})])
}
var staticRenderFns = []

export default { render: render }